import * as Types from '../generated.types'

export type EmployeeInfoFragment = {
  __typename?: 'Employee'
  id: number
  employmentStartDate?: string | null
  role: Types.EmployeeRole
  enrollmentInfo: {
    __typename?: 'EmployeeEnrollment'
    accountStatus: Types.EmployeeAccountStatus
    payrollSystemStatus?: Types.EmployeePayrollSystemStatusEnum | null
  }
  user: {
    __typename?: 'User'
    id: number
    email?: string | null
    firstName?: string | null
    lastName?: string | null
  }
  paygroupInfo: { __typename?: 'EmployerInfo'; id: number; name?: string | null }
  rosterEntryOverride?: {
    __typename?: 'RosterEntryOverride'
    payrollSystemStatus?: Types.EmployeePayrollSystemStatusEnum | null
  } | null
}

export const EmployeeInfoFragmentDoc = `
    fragment EmployeeInfo on Employee {
  id
  employmentStartDate
  role
  enrollmentInfo {
    accountStatus
    payrollSystemStatus
  }
  user {
    id
    email
    firstName
    lastName
  }
  paygroupInfo {
    id
    name
  }
  rosterEntryOverride {
    payrollSystemStatus
  }
}
    `
